import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader, ModalFooter, Button, Row, Col, Label} from "reactstrap";
import {FormattedMessage} from "react-intl";
import PropTypes from 'prop-types';
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import { connect } from 'react-redux';
import {addBlock} from '../../../../data/blocks/actions';
import Select from "react-select";
import SelectBlocks from "../../../SelectBlocks";
import _ from "lodash";

class BlockModal extends Component {

  constructor(props) {
    super(props);

    let all = document.querySelectorAll("[data-type='blockCard']");
    let blockId;

    for (let i = 0; i < all.length; i++) {
      if (!all[i + 1]) {
        blockId = parseInt(all[i].getAttribute('data-id'));
        break;
      }

      let nextRect = all[i + 1].getBoundingClientRect();

      if (nextRect.top - nextRect.height - 80 > 0) {
        blockId = parseInt(all[i].getAttribute('data-id'));
        break;
      }
    }

    if (all.length === 0 && Object.keys(props.blocks).length > 0) {
      blockId = _.sortBy(props.blocks, block => block.position)[0].id;
    }

    this.state = {
      loading: false,
      shift: { value: 0, label: <FormattedMessage id="createElementButton.blockModal.label.shift.before"/>},
      block: Object.keys(props.blocks).length > 0 ? blockId : null,
    };

    this.addBlock = this.addBlock.bind(this);
  }

  addBlock() {
    this.setState({loading: true});

    const set = this.state.block
      ? _.find(this.props.sets, set => set.blockPages.includes(this.state.block))
      : _.sortBy(this.props.sets, set => set.position)[0];

    const position = this.state.block
        ? _.find(this.props.blocks, block => block.id === this.state.block).position + this.state.shift.value
        : 0;

    const data = {
      set: set.id,
      block: {
        position: position
      }
    };

    this.props.addBlock(data).then(() => {
      this.setState({loading: false});
      this.props.toggle();
    })
  }

  render() {
    const hasSets = Object.keys(this.props.sets).length > 0;

    return (
      <Modal size="xl" isOpen={true} toggle={this.props.toggle}>
        <ModalHeader toggle={this.props.toggle}><FormattedMessage id="createElementButton.blockModal.modalHeader" /></ModalHeader>
        <hr className="my-0" />
        <ModalBody>
          {!hasSets ? <p><FormattedMessage id="createElementButton.blockModal.modalBody.noSets" /></p> : <React.Fragment>
            {!this.state.block ? <p><FormattedMessage id="createElementButton.blockModal.modalBody.firstBlock"/></p> : <React.Fragment>
              <Row>
                <Col lg={3}>
                  <Label for="shift"><FormattedMessage id="createElementButton.blockModal.label.shift" /></Label>
                </Col>
                <Col lg={9}>
                  <Select
                    clearable={false}
                    value={this.state.shift}
                    options={[
                      { value: 0, label: <FormattedMessage id="createElementButton.blockModal.label.shift.before" />},
                      { value: 1, label: <FormattedMessage id="createElementButton.blockModal.label.shift.after" />},
                    ]}
                    onChange={shift => this.setState({shift: shift})}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col lg={3}>
                  <Label for="shift"><FormattedMessage id="createElementButton.blockModal.label.block" /></Label>
                </Col>
                <Col lg={9}>
                  <SelectBlocks
                    isMulti={false}
                    onChange={block => this.setState({block})}
                    value={this.state.block}
                  />
                </Col>
              </Row>
            </React.Fragment>}
          </React.Fragment>}
        </ModalBody>
        <ModalFooter>
          <FormattedMessage id="_.button.add">{
            (message) => <LaddaButton
              className="btn btn-success btn-ladda"
              data-style={ZOOM_OUT}
              loading={this.state.loading}
              onClick={this.addBlock}
              disabled={!hasSets}
            >
              {message}
            </LaddaButton>
          }</FormattedMessage>
          <FormattedMessage id="_.button.cancel">{
            (message) =>
              <Button color="secondary" onClick={this.props.toggle}>{message}</Button>
          }</FormattedMessage>
        </ModalFooter>
      </Modal>
    )
  }
}

BlockModal.propTypes = {
  toggle: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  let blocks = [];

  _.each(state.survey.structure.data.survey.setBlocks, setId => {
    let set = state.survey.structure.data.sets[setId];

    _.each(set.blockPages, blockId => {
      blocks.push(state.survey.structure.data.blocks[blockId]);
    });
  });

  return {
    sets: state.survey.structure.data.sets,
    blocks
  }
}

export default connect(mapStateToProps, {addBlock})(BlockModal);